import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdateEmailRecipientInterface {
  id?: string
  recipientEmail?: string
  isActive?: boolean
}

// ServiceName/ServiceNameDescription/PartnerId are immutable after creation — see backend
// UpdateNotificationRecipientRequest. Only the email and active status can change.
export const useUpdateEmailRecipient = () => {
  const mutate = useMutation(
    ({ id, recipientEmail, isActive }: UpdateEmailRecipientInterface) => {
      return putAPI(`/NotificationRecipient/${id}/Update`, {
        id: id,
        recipientEmail: recipientEmail,
        isActive: isActive,
      })
    },
  )

  return mutate
}

export default useUpdateEmailRecipient
